import MainLayout from '@layouts/main-layout'
import AccountLayout from '@modules/account/templates/account-layout'
import OverviewTemplate from '@modules/account/templates/overview-template'
import { ReactElement } from 'react'
import { NextPageWithLayout } from 'types/global'

const Account: NextPageWithLayout = () => {
  return (
    <>
      <OverviewTemplate />
    </>
  )
}

Account.getLayout = (page: ReactElement) => {
  return (
    <MainLayout>
      <AccountLayout>{page}</AccountLayout>
    </MainLayout>
  )
}

export default Account
